export const config = {
  title: "Bull Electric | Electrical & Home Improvement Services in Westport, MA",
  meta: {
    description:
      "Bull Electric provides expert electrical and home improvement services in Westport, MA. Led by Master Electrician Eugene 'Sam' Smith with over 39 years of experience, specializing in wiring, lighting, panel upgrades, smart home solutions, and general renovations.",
    keywords: [
      "Bull Electric",
      "electrician Westport MA",
      "residential wiring",
      "panel upgrades",
      "lighting installation",
      "energy-efficient solutions",
      "smart home installation",
      "home improvement services Westport"
    ],
    author: "Bull Electric",
    canonicalUrl: "https://www.bullelectric.info/",
  },
  sections: {
    header: {
      businessName: "Bull Electric",
    },
    sectionB: {
      heroTitle: "Power That NEVER Backs Down!",
      heroSubtitle: "Reliable Electrical & Home Improvement Services in Westport, MA",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "5084966202",
      phoneLabel: "(508) 496-6202",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1409304338/photo/electricity-and-electrical-maintenance-service-engineer-hand-holding-ac-multimeter-checking.jpg?s=612x612&w=0&k=20&c=Pj3gqobTp67aPN8l-lm6q-uT2DDnm-aeFk7Gkvmbaok=",
      cardData: [
        {
          title: "Residential Wiring",
          description: "Safe and reliable wiring installations, troubleshooting, and repairs.",
        },
        {
          title: "Lighting Installation",
          description: "Illuminate your home or business with professional lighting solutions.",
        },
        {
          title: "Panel Upgrades",
          description: "Upgrade your electrical panels to meet modern energy demands.",
        },
      ],
      description:
        "At Bull Electric, we provide licensed electrical and handyman services backed by over 39 years of hands-on experience. From wiring and lighting to home renovations and smart technology, we deliver work that meets code, exceeds expectations, and powers your life with confidence.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive electrical and home improvement solutions tailored to your needs.",
      cards: [
        {
          title: "Residential Wiring",
          description: "Complete electrical installation, troubleshooting, and repairs.",
          imageSrc: "https://media.istockphoto.com/id/1015452484/photo/home-electrical-system.jpg?s=612x612&w=0&k=20&c=3VLcxw7UgR8VZ15YiTcGmYjXqyX45lkaxcjaGC24jac=",
          imageAlt: "Residential Wiring",
        },
        {
          title: "Energy-Efficient Solutions",
          description: "Save on energy costs with modern, sustainable upgrades.",
          imageSrc: "https://media.istockphoto.com/id/2053337498/photo/asian-business-people-team-brainstorm-meeting-in-sustainable-office-at-night-using-computer.jpg?s=612x612&w=0&k=20&c=92199lBFTEtbVNb8AWLjmYPThYII4xMm7aNNtuh4w8o=",
          imageAlt: "Energy-Efficient Upgrades",
        },
        {
          title: "Smart Home Integration",
          description: "Seamlessly integrate smart home technologies for comfort and security.",
          imageSrc: "https://media.istockphoto.com/id/1361971731/photo/smart-kitchen-concept.jpg?s=612x612&w=0&k=20&c=o37FO71tBdVXdkvOo4xnsFjYA2EisYFYc4RfBSBDc6g=",
          imageAlt: "Smart Home Solutions",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Kitchen & Bathroom Renovations",
        "Decks, Patios & Outdoor Living Spaces",
        "Drywall & Custom Carpentry",
        "Window & Door Installation",
        "General Repairs & Maintenance",
        "Military Discount for Service Members & Families"
      ],
    },
    sectionD: {
      aboutTitle: "About Bull Electric",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1345765714/photo/electrical-engineers-test-electrical-installations-and-wiring-on-protective-relays-measuring.jpg?s=612x612&w=0&k=20&c=Go95zj7drMZVNTaPS615U5Yjsl_y1cvTHqoyJirLMlA=",
        alt: "Bull Electric Team",
      },
      aboutText: [
        "Founded by Eugene 'Sam' Smith, a licensed Master Electrician with over 39 years of experience, Bull Electric is built on honesty, precision, and dedication to customer satisfaction.",
        "We are fully licensed and insured, proudly serving Westport, MA, and surrounding communities with top-quality electrical and handyman services.",
      ],
    },
    sectionE: {
      profileImage: "https://static.wixstatic.com/media/c9f615_ab97320798a44aa498535fa023e8624a~mv2.png/v1/fill/w_580,h_741,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/c9f615_ab97320798a44aa498535fa023e8624a~mv2.png",
      profileAlt: "Bull Electric Logo",
      businessName: "Bull Electric",
      contact: {
        phone: "5084966202",
        phoneLabel: "(508) 496-6202",
        email: "Bullelectric8127@gmail.com",
        website: "https://www.bullelectric.info/",
        address: "Westport, MA",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "Westport, MA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2947.299999!2d-71.083!3d41.610!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e52a8b1234567%3A0xabcdef123456789!2sWestport%2C%20MA!5e0!3m2!1sen!2sus!4v1714567890123!5m2!1sen!2sus",
    },
  },
};

export default config;
